import StudioMap from "./studio-map";

export default class StudioMapView
{
  private readonly mouseOverHandler: EventListener;
  private readonly mouseOutHandler: EventListener;
  private readonly clickHandler: EventListener;

  public readonly id: string;
  public readonly slideIndex: number;
  private readonly studioMap: StudioMap;
  private readonly camera: SVGCircleElement;
  private readonly view: SVGPathElement | null = null;
  constructor(studioMap: StudioMap, camera: SVGCircleElement, slideIndex: number)
  {
    this.studioMap = studioMap;
    this.camera = camera;
    this.slideIndex = slideIndex;
    this.id = this.camera.id.replace('kamera-', '');

    const view = this.studioMap.wrapper.querySelector('#pohled-' + this.id);
    if(view instanceof SVGPathElement)
    {
      this.view = view;
    }

    this.camera.setAttribute('transform-origin', this.camera.getAttribute('cx') + ' ' + this.camera.getAttribute('cy'))

    this.clickHandler = this.handleClickEvent.bind(this);
    this.mouseOverHandler = this.handleMouseOverEvent.bind(this);
    this.mouseOutHandler = this.handleMouseOutEvent.bind(this);

    this.enable();
  }

  public enable(): void
  {
    this.setEnabled(true);
    this.camera.addEventListener('click', this.clickHandler, false);
    this.camera.addEventListener('mouseover', this.mouseOverHandler, false);
    this.camera.addEventListener('mouseout', this.mouseOutHandler, false);
  }

  private handleMouseOverEvent(event: MouseEvent): void
  {
    this.view?.classList.add('is-hover');
  }

  private handleMouseOutEvent(event: MouseEvent): void
  {
    this.view?.classList.remove('is-hover');
  }

  private handleClickEvent(event: Event): void
  {
    this.studioMap.setView(this);
    // this.studioMap.swiper.el.scrollIntoView();
  }

  public setActive(isActive: boolean = true): void
  {
    this.camera.classList.toggle('is-active', isActive);
    this.view?.classList.toggle('is-active', isActive);
  }
  private setEnabled(isEnabled: boolean = true): void
  {
    this.camera.classList.toggle('is-enabled', isEnabled);
    this.view?.classList.toggle('is-enabled', isEnabled);
  }
}